<script setup lang="ts">
import type { IWorkOrderShipment } from '@/types/rc/shipments'

defineProps<{ shipment: IWorkOrderShipment }>()
</script>

<template>
  <div class="shipment-container">
    <div class="shipment-container__header">
      <span class="shipment-container__header__carrier">{{ shipment.carrier ?? 'No carrier set' }}</span>
      <span class="shipment-container__header__date">{{ shipment.status }}</span>
    </div>
    <div class="shipment-container__body">
      <span class="shipment-container__body__tracking-number">{{
        shipment.tracking_number ?? 'No tracking information'
      }}</span>
    </div>
  </div>
</template>

<style scoped lang="scss">
.shipment-container {
  display: flex;
  background: var(--component-stroke-primary);
  border-radius: var(--spacing-spacing-2xs);
  padding: var(--spacing-spacing-sm);

  &__header {
    display: flex;
    justify-content: space-between;

    &__carrier {
      color: var(--text-secondary);
      font-size: var(--font-size-body-compact);
      line-height: 20px;
      font-weight: 400;
      text-align: left;
      white-space: nowrap;
    }

    &__date {
      display: flex;
      justify-content: flex-end;
      color: var(--text-secondary);
      font-size: var(--font-size-body-compact);
      font-weight: 500;
      line-height: 20px;
      text-align: right;
      white-space: nowrap;
    }
  }

  &__body {
    display: flex;
    gap: var(--spacing-spacing-xs);

    &__tracking-number {
      color: var(--text-primary);
      font-size: var(--font-size-body-compact);
      font-weight: 400;
      line-height: 20px;
      text-align: left;
      white-space: nowrap;
    }
  }
}

.shipment-container:hover {
  background: var(--component-stroke-secondary);
  cursor: pointer;
}
</style>
